/**
 * Test Page for Content Upload Manager
 * Modular UI with accordion for 5 content types
 */

import React, { useState } from 'react'
import { ContentUploadManager } from '../../components/teacher/ContentUpload'

const TestContentUploadManager: React.FC = () => {
    const [lop, setLop] = useState('11')
    const [chuong, setChuong] = useState('2')
    const [bai, setBai] = useState('6')

    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 p-6">
            <div className="max-w-5xl mx-auto">
                <ContentUploadManager
                    lop={lop}
                    chuong={chuong}
                    bai={bai}
                    onLopChange={setLop}
                    onChuongChange={setChuong}
                    onBaiChange={setBai}
                />
            </div>
        </div>
    )
}

export default TestContentUploadManager
